import { Skeleton } from '@modulor/react';
import clx from 'classnames';
import React from 'react';

import { getLayoutType, LayoutType } from '../../../../utils';
import SkeletonArray from '../SkeletonArray';
import style from './SkeletonDefaultInit.module.scss';

const SkeletonDefaultInit = ({ showHeader = false }: { showHeader?: boolean }) => {
  const isMobile = getLayoutType() === LayoutType.mobile;

  return (
    <>
      {showHeader && (
        <div className={style.title}>
          <Skeleton width={120} height={16} borderRadius={100} marginBottom={18} />
        </div>
      )}
      {isMobile ? (
        <div className={clx(style.listWrapper, style.mobile)}>
          <SkeletonArray length={6}>
            <Skeleton width="100%" height={40} borderRadius={12} marginBottom={4} padding={8}>
              <div className={style.item}>
                <div className={style.img} />
                <div className={style.description} />
              </div>
            </Skeleton>
          </SkeletonArray>
        </div>
      ) : (
        <div className={style.container}>
          <div className={style.listWrapper}>
            <SkeletonArray length={4}>
              <Skeleton width="auto" height={40} borderRadius={12} marginBottom={4} padding={8}>
                <div className={style.item}>
                  <div className={style.img} />
                  <div className={style.description} />
                </div>
              </Skeleton>
            </SkeletonArray>
          </div>
          <div className={style.listWrapper}>
            <SkeletonArray length={4}>
              <Skeleton width="auto" height={40} borderRadius={12} marginBottom={4} padding={8}>
                <div className={style.item}>
                  <div className={style.img} />
                  <div className={style.description} />
                </div>
              </Skeleton>
            </SkeletonArray>
          </div>
        </div>
      )}
    </>
  );
};

export default SkeletonDefaultInit;
